<div class="row">
    <div class="col-md-2 mb-5" *ngFor="let movie of movies">
        <img [src]="movie.poster_path | poster" alt="" class="img-fluid poster mb-3" (click)="onMovieClick( movie )">
        <div>
            <h3 class="poster-title">{{ movie.title }}</h3>
            <div class="row">
                <div class="col-10 poster-stars">
                    <star-rating [value]="movie.vote_average / 2" checkedcolor="yellow" uncheckedcolor="grey" size="14px">
                    </star-rating>
                </div>
                <div class="col-2 poster-vote-average">
                    {{ movie.vote_average | number:'1.1'}}
                </div>
            </div>
        </div>
    </div>
</div>